import script from "./MSegmentedControl.vue?vue&type=script&setup=true&lang=js"
export * from "./MSegmentedControl.vue?vue&type=script&setup=true&lang=js"

import "./MSegmentedControl.vue?vue&type=style&index=0&id=02cc8f71&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-02cc8f71"]])

export default __exports__